/**
 * The clients' rule of a bag, order or return line. This file imports nothing, so the operator apps load it through
 * the `@brandclub/common-ui/BrandclubLanding/BrandclubCheckout/lineIdentity` sub-export without the common-ui tree.
 */

type Choice = { subscriptionFrequency?: unknown; subscription?: unknown };
type Line = Choice & { retailerSku: string };

/** A bag line holds a frequency, and a checkout line holds a subscription. Either one makes it a subscription line. */
export const isSubscriptionLine = (line: Choice): boolean => Boolean(line.subscriptionFrequency || line.subscription);

/** Both lines are subscription lines, or both are one-time lines. The frequency does not matter. */
export const isSamePurchaseChoice = (a: Choice, b: Choice): boolean => isSubscriptionLine(a) === isSubscriptionLine(b);

/**
 * A bag line is a product and its purchase choice. The frequency is not part of it, so a product has one
 * subscription line.
 */
export const isSameBagLine = (a: Line, b: Line): boolean => a.retailerSku === b.retailerSku && isSamePurchaseChoice(a, b);

export const bagLineKey = (line: Line): string =>
  isSubscriptionLine(line) ? `${line.retailerSku}:subscription` : line.retailerSku;

/** A return request names a subscription line with `subscription: true`. A one-time line adds no field. */
export const returnLineChoice = (line: Choice) => (isSubscriptionLine(line) ? { subscription: true as const } : {});
